import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMDescriptionCard } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";

/**
 * Adds the achievements, next-steps and challenges description cards, in
 * that order (#2222).
 */
export function addNarrativeDescriptionCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  const achivementsDescriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "achievementsDescriptionComponent",
      description:
        getLocalizedMessage(language, "achievementsDescription") ||
        "This is the achievements description of the dashboard",
      title: getLocalizedMessage(language, "achievements") || "Achievements",
      labels: ["achievements"],
    },
  });

  achivementsDescriptionComponent.mapState((appState) => {
    const language = appState.language || "en";
    const project = appState.currentReport?.project;
    return {
      showInfoIcon: false,
      showMenuIcon: false,

      title: getLocalizedMessage(language, "achievements") || "Achievements",
      description:
        getLocalizedMessage(
          appState.language || "en",
          "achievementsDescription"
        ) || "This is the achievements description of the dashboard",
      text: project?.achievements ?? "",
    };
  });

  achivementsDescriptionComponent.mapVisibility(
    (state) =>
      state.settings?.configuration?.fieldsDefinition?.some(
        (field) => field.fieldName === "achievements" && field.enabled === true
      ) ?? false
  );

  const nextStepsDescriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "nextStepsDescriptionComponent",
      description:
        getLocalizedMessage(language, "nextStepsDescription") ||
        "This is the next steps description of the dashboard",
      title: getLocalizedMessage(language, "nextSteps") || "Next Steps",
      labels: ["nextSteps"],
    },
  });

  nextStepsDescriptionComponent.mapState((appState) => {
    const language = appState.language || "en";
    const project = appState.currentReport?.project;
    return {
      showInfoIcon: false,
      showMenuIcon: false,

      title: getLocalizedMessage(language, "nextSteps") || "Next Steps",
      description:
        getLocalizedMessage(
          appState.language || "en",
          "nextStepsDescription"
        ) || "This is the next steps description of the dashboard",
      text: project?.nextSteps ?? "",
    };
  });
  nextStepsDescriptionComponent.mapVisibility(
    (state) =>
      state.settings?.configuration?.fieldsDefinition?.some(
        (field) => field.fieldName === "nextSteps" && field.enabled === true
      ) ?? false
  );

  const challengesComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "challengesDescriptionComponent",
      description:
        getLocalizedMessage(language, "challengesDescription") ||
        "This is the challenges description of the dashboard (TODO)",
      title: getLocalizedMessage(language, "challenges") || "Challenges",
      labels: ["challenges"],
    },
  });

  challengesComponent.mapState((appState) => {
    const language = appState.language || "en";
    const project = appState.currentReport?.project;
    return {
      showInfoIcon: false,
      showMenuIcon: false,

      title: getLocalizedMessage(language, "challenges") || "Challenges",
      description:
        getLocalizedMessage(
          appState.language || "en",
          "challengesDescription"
        ) || "This is the challenges description of the dashboard",
      text: project?.challenges ?? "",
    };
  });

  challengesComponent.mapVisibility(
    (state) =>
      state.settings?.configuration?.fieldsDefinition?.some(
        (field) => field.fieldName === "challenges" && field.enabled === true
      ) ?? false
  );
}
